import Warning from "@mui/icons-material/Warning";

import { makeSvgIcon } from "./svg-icon";

export const ErrorIcon = makeSvgIcon(
  Warning,
  (theme) => theme.palette.error.main
);

export default ErrorIcon;
